export default __webpack_public_path__ + "static/Graphik-Light-1bff1621478328adb8b594ee0a6bf428.otf";